import React, { useState } from 'react'
import toast from '../../shared/Toast'
import { bookingSeriesService } from '../../../_services/bookingSeries.service'
import { forgetRepeat } from './undo'
import './Repeat.css'

// Undo a repeat just booked: every visit goes, the client is sent nothing,
// deposits are refunded. The diary reloads the way it does after a booking.
export const undoRepeat = seriesId => bookingSeriesService.undo(seriesId)
  .then((res) => {
    forgetRepeat(seriesId)
    toast.success('Repeat removed. Nothing was sent to the client.')
    const failed = (res && res.failed) || []
    if (failed.length) toast.error(`${failed.length} visit${failed.length === 1 ? '' : 's'} couldn’t be removed. Cancel ${failed.length === 1 ? 'it' : 'them'} from the diary.`)
    try { window.dispatchEvent(new CustomEvent('diary:booking-created', { detail: {} })) } catch (e) { /* ignore */ }
    return res
  })
  .catch((e) => {
    // Too late, or not theirs: the server says which. Either way it's gone
    // from here.
    forgetRepeat(seriesId)
    toast.error((e && e.message) || 'Couldn’t undo the repeat. Try again.')
    throw e
  })

// The "Booked 9 visits" toast, with Undo beside the words
export const UndoToast = ({ text, seriesId }) => {
  const [state, setState] = useState('ready')
  const go = () => {
    if (state !== 'ready') return
    setState('busy')
    undoRepeat(seriesId).then(() => setState('done'), () => setState('done'))
  }
  return (
    <span className="rpt-undo-toast">
      <span>{state === 'done' ? 'Undone.' : text}</span>
      {state !== 'done' && (
        <button type="button" className="rpt-link" onClick={go} disabled={state === 'busy'}>{state === 'busy' ? 'Undoing...' : 'Undo'}</button>
      )}
    </span>
  )
}
